var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppTransition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"assistant-error"},[_c('div',{staticClass:"assistant-error__text"},[_vm._v("\n      "+_vm._s(_vm.$t('assistant.loadingErrorText'))+"\n\n      "),(_vm.details)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.details)}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }